/**
 * @generated SignedSource<<a71688dc1046cca9ee5f56784cc9704f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSaveProductDisableVTOMutation$variables = {
  id: string;
};
export type useSaveProductDisableVTOMutation$data = {
  readonly disableTryOnProduct: {
    readonly productTryOn: {
      readonly id: string;
    } | null;
  };
};
export type useSaveProductDisableVTOMutation = {
  response: useSaveProductDisableVTOMutation$data;
  variables: useSaveProductDisableVTOMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProductTryOnOutput",
    "kind": "LinkedField",
    "name": "disableTryOnProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTryOn",
        "kind": "LinkedField",
        "name": "productTryOn",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveProductDisableVTOMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSaveProductDisableVTOMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "4da7a5dd4438d6645c88b5089aad1e2d",
    "id": null,
    "metadata": {},
    "name": "useSaveProductDisableVTOMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveProductDisableVTOMutation(\n  $id: ID!\n) {\n  disableTryOnProduct(id: $id) {\n    productTryOn {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b399a7460ac50236b0ef11a74b5b323d";

export default node;
